export default {
    homeContainer: {
        backgroundColor: '#f2f2f2',

    }
}